import {
  isMobileStyleMixin,
  styleMixinInvertedFocusOutline,
  Text,
  TextButton,
} from '@amzn/storm-ui';
import styled, { css } from 'styled-components';

export const ContextBarWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: start;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.xxxsmall.default};
  ${isMobileStyleMixin(css`
    align-items: center;
    padding: ${({ theme }) => theme.spacing.xsmall.default};
  `)}
`;

export const MobileMenuButton = styled(TextButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 11px;
  color: ${({ theme }) => theme.color.gray[0]};
  margin-inline-end: ${({ theme }) => theme.spacing.xsmall.default};

  &:hover,
  &:active {
    color: ${({ theme }) => theme.color.gray[0]};
  }

  &:focus-visible {
    ${styleMixinInvertedFocusOutline};
  }
`;

export const MobileMenuButtonIcon = styled.svg`
  width: 18px;
  height: 16px;

  & > path {
    fill: ${({ theme }) => theme.color.gray[0]};
  }
`;

export const BreadcrumbsPageName = styled(Text)<{ ia2Enabled?: boolean }>`
  ${isMobileStyleMixin(css`
    font-size: 15px;
  `)}
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
`;

export const PageHeaderSectionWrapper = styled.a`
  && {
    text-decoration: none;
  }

  border-radius: ${({ theme }) => theme.border.radius.medium};

  :focus {
    outline: none;
  }

  :focus-visible {
    ${styleMixinInvertedFocusOutline};
  }
`;

export const AppNameSectionWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const CategoryTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & span[class*='Tag-sc-storm-ui'] {
    bottom: 1px;
  }
`;
